import React from 'react'

export const HelpPanel = () => (
    <div style={{width: 200, padding: 15}}>
        <h4>Help</h4>
        <p>The best way to learn about Circuit Builder is to watch the <a style={{color: 'white', lineHeight: '1.2em'}} href="https://www.youtube.com/watch?v=fPzWDmVEmyM" target="_blank" rel="noopener noreferrer">introduction video</a>.</p>
        </div>
);